import { HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectRegionalCountry } from 'projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';

function getCountry() {
  return navigator.language.split('-')[1].toUpperCase();
}

function toSnakeCase(str: string | null | undefined): string {
  if (!str || typeof str !== 'string') return '';
  return str.toLowerCase().trim().replace(/\s+/g, '_');
}

function getCountryCode(): string {
  const store = inject(Store);
  const country = store.selectSignal(SelectRegionalCountry)();
  if (!country) return 'eg';
  return toSnakeCase(country);
}

export const UserCountryInterceptor: HttpInterceptorFn = (request, next) => {
  const countriesCodes = inject(countriesService)
  const clonedReq = request.clone({
    headers: request.headers.set(
      'X-User-Country',
      countriesCodes.countryCodes[getCountryCode()] ?? getCountry(),
    ),
  });
  return request.url.includes('suggestions') ? next(request) : next(clonedReq);
};
